import type { InputHTMLAttributes } from 'react'

export type TimePickerValidationState = 'default' | 'valid' | 'invalid'

export interface TimeValue {
  hours: number
  minutes: number
  seconds?: number
}

export interface TimePickerProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'size'> {
  value?: TimeValue | null
  onChange?: (time: TimeValue | null) => void
  format?: '12' | '24'
  showSeconds?: boolean
  minuteStep?: number
  placeholder?: string
  minTime?: TimeValue
  maxTime?: TimeValue
  validationState?: TimePickerValidationState
  error?: string
  helperText?: string
  size?: 'sm' | 'md' | 'lg'
  hideMessage?: boolean
}

export const sizeStyles = {
  sm: 'px-2.5 py-1.5 text-sm',
  md: 'px-3 py-2 text-base',
  lg: 'px-4 py-3 text-lg',
}

export const validationStyles: Record<TimePickerValidationState, string> = {
  default: 'border-border focus:border-ring focus:ring-ring',
  valid: 'border-green-500 focus:border-green-500 focus:ring-green-500',
  invalid: 'border-red-500 focus:border-red-500 focus:ring-red-500',
}
